<template>
  <div class="component-startup-create__step-eligibility">
    <h2 class="component-startup-create__step-eligibility__title">
      Let’s confirm your eligibility:
    </h2>

    <div class="component-startup-create__step-eligibilitymt-4">
      <h3 class="component-startup-create__step-eligibility__sub-title">
        Are you...
      </h3>

      <ul class="component-startup-create__step-eligibility__list">
        <li class="component-startup-create__step-eligibility__list__item">
          - A Nordic based investor or an investor who are already investing in
          Nordic startups?
        </li>
        <li class="component-startup-create__step-eligibility__list__item">
          - A registered business with a company website or an individual with
          an updated Linkedin profile?
        </li>
      </ul>
    </div>

    <FormItem
      class="mt-20"
      invalid-message="You have to confirm that your startup is eligible"
      :state="$v.criterias.$dirty ? !$v.criterias.$error : null"
    >
      <div class="component-startup-create__step-eligibility__checkbox">
        <b-form-checkbox
          v-model="form.criterias"
          @input="$v.criterias.$touch()"
        >
          <div class="ml-10">I confirm I am eligible</div>
        </b-form-checkbox>
      </div>
    </FormItem>
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem/index'
export default {
  name: 'CompanyFormStepEligibility',
  components: {
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      }
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.component-startup-create__step-eligibility {
  &__title {
    font-size: 2.4rem;
  }

  &__sub-title {
    margin-top: 3rem;
    font-size: 1.9rem;
  }

  &__list {
    margin: 2rem 0 0 0;
    padding: 0;

    &__item {
      list-style: none;
      color: $gray-700;
      padding-bottom: 0.7rem;
      font-size: 1.1rem;
    }
  }

  &__checkbox {
    background: #fff;
    padding: 0.8rem 1rem;
    border-radius: 0.25rem;
    background: $gray-100;
    align-items: center;
    display: flex;
  }
}
</style>
